import React from 'react';
import { MotoManager } from '../components/admin/MotoManager';
import { useStore } from '../stores/appStore';
import { X } from 'lucide-react';

export default function AdminPage() {
  const { loginAdmin, isAdmin } = useStore();

  React.useEffect(() => {
    if (!isAdmin) loginAdmin();
  }, [isAdmin, loginAdmin]);

  return (
    <div className="min-h-screen bg-gray-100">
      <header className="bg-gray-900 text-white p-4 flex items-center justify-between">
        <h1 className="text-xl font-bold">Admin - VendaMotos</h1>
        <a href="/" className="flex items-center gap-2 px-3 py-2 bg-gray-800 rounded hover:bg-gray-700">
          <X size={18} />
          <span>Voltar</span>
        </a>
      </header>
      <main className="max-w-5xl mx-auto p-6">
        <MotoManager />
      </main>
    </div>
  );
}
